import React from 'react'
import "./loader.css"

const Loader = () => {
  return (
    <div className='loading'><div></div></div>
  )
}

export default Loader